import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'keys' })
export class KeysPipe implements PipeTransform {
  transform(value: any): string[] {
    if (value === null || value === undefined) {
      return [];
    }
    return Object.keys(value);
  }
}
